import { facebookLogin } from './_duck'
import * as types from './types'

// Types
import {
  ModuleTypeLoginFacebook,
} from './_definitions'
import { PayloadAction } from '../../types'

const initialModuleStateLoginFacebook: ModuleTypeLoginFacebook = {
  hasErrMessage: false,
  loginFacebookSuccess: null,
  statusLoginFacebook: null,
}

const reducer = facebookLogin.createReducer(
  {
    [types.LOGIN_WITH_FACEBOOK_REQUEST]: (
      state: ModuleTypeLoginFacebook,
    ): ModuleTypeLoginFacebook => ({
      ...state,
      hasErrMessage: false,
    }),
    [types.LOGIN_WITH_FACEBOOK_SUCCESS]: (
      state: ModuleTypeLoginFacebook,
      { payload }: PayloadAction,
    ): ModuleTypeLoginFacebook => ({
      ...state,
      loginFacebookSuccess: true,
      statusLoginFacebook: payload,
    }),
    [types.LOGIN_WITH_FACEBOOK_FAILURE]: (
      state: ModuleTypeLoginFacebook,
    ): ModuleTypeLoginFacebook => ({
      ...state,
      hasErrMessage: true,
      loginFacebookSuccess: false,
    }),
    [types.LOGIN_WITH_FACEBOOK_CLEAN]: (
      state: ModuleTypeLoginFacebook,
    ): ModuleTypeLoginFacebook => ({
      ...state,
      loginFacebookSuccess: null,
    }),   
  },
  {
    initialModuleStateLoginFacebook
  },
)

export default reducer
